module.exports = __webpack_public_path__ + "assets/images/limited_activity_y.d2dc195c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/limited_activity_y.png
// module id = 754
// module chunks = 1